<template>
    <div>
        <b-row v-for="(cat, index) in catList" class="mb-1 hoverRow">
            <b-col class="d-flex align-items-center">
                <span class="font-weight-bold mr-2">
                    {{ cat.catName }}
                </span>

                <b-form-input placeholder="0" size="sm" style="width: 80px; font-size: 1em;"
                    class="text-primary text-center rounded-0 " v-model.number="catSettingValue[cat.catCode]"
                     />


                <button class="btn btn-sm rounded-0" 
                    :class="{'btn-primary': catTimesAmount[cat.catCode].length != 0, 'btn-danger': catTimesAmount[cat.catCode].length == 0}"
                    :disabled="!catSettingValue[cat.catCode] || catSettingValue[cat.catCode]==0"
                    style="cursor: pointer;border-right: 1px solid #ccc;" @click="onOpenSlaDateModal(cat)">
                    <feather-icon v-if="!isLoading" icon="SettingsIcon" />
                    <b-spinner v-else small label="Spinning"></b-spinner>
                </button>
                
                <span class="ml-2 text-sm ">                   
                    <span v-if="catSettingValue[cat.catCode] >0" class="text-primary">
                        ({{convertHourToText(catSettingValue[cat.catCode] || 0) }}, {{ displayCatTimeDetail(cat.catCode).count }} days,  {{ displayCatTimeDetail(cat.catCode).mondayInfo }})
                        <span v-if="catTimesAmount[cat.catCode].length == 0" class="text-danger ml-1">**ยังไม่ได้กรอกเวลา</span>
                    </span>
                    <span v-else class="text-danger">{{ (catTimesAmount[cat.catCode].length == 0 || catSettingValue[cat.catCode]==0 || !catSettingValue[cat.catCode]) ? "ปิดการใช้งาน":"" }} </span>
                </span>
                <!-- <span class="ml-2">**ทุกวัน</span> -->
            </b-col>

        </b-row>
        <b-row >
            <b-col>
                <span style="font-size:0.8em">หมายเหตุ : เมื่อตั้งค่าจะมี CAT 5 แสดงใน Brand นั้นเมื่อเปิดใบงาน และตั้งค่าเป็น 0 เมื่อไม่ต้องการให้แสดงเวลาเปิดใบงาน </span>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col>
                <b-button variant="primary" size="sm" style="height: 35px" class="mr-1" @click="onSubmit">
                    <feather-icon icon="SaveIcon" />
                    บันทึก
                </b-button>
            </b-col>
        </b-row>

    </div>

</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BButton,
    BFormCheckbox,
    BInputGroup,
    BFormInput,
    BFormTextarea,
    BFormRadioGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
} from "bootstrap-vue";

import CatService from "@/services/setting/cat";

export default {
    props: ["type", "alias", "catList", "catValue","catTimesAmount"],
    components: {
        BRow,
        BCol,
        BCard,
        BFormGroup,
        BButton,
        BFormInput,
        BInputGroup,
        BFormCheckbox,
        BFormTextarea,
        BFormRadioGroup,
        BInputGroupPrepend,
        BInputGroupAppend,
    },
    data() {
        return {
            isLoading:false,
            isShowCat5: false,
            catSettingValue: {    //CAT 1 = 4 hour....
                CAT1: null,
                CAT2: null,
                CAT3: null,
                CAT4: null,
                CAT5: null
            },
           
        }
    },

    computed: {
        paramSubCompanyId() {
            return this.$route.query.scid
        },
    },
    watch: {
        catValue: {
            immediate: true,
            handler(val) {
                this.catSettingValue = val
            }
        },   
        
     
        
    },
   
    methods: {
        async onOpenSlaDateModal(cat) {
            this.isLoading = false
            this.$store.commit('sla/SET_CAT_TIME_SELECTED', null)
            this.$store.commit('sla/SET_SLA_SELECTED', cat)
            this.$store.commit('sla/SET_TAB_ALIAS_SELECTED', this.alias)
            this.$bvModal.show("sla-date-modal");

            const catTimeList = await this.onFetchCatTime(cat.catCode)
            const catTimeBuilded = this.buidCatTime(catTimeList)
            
            this.$store.commit('sla/SET_CAT_TIME_SELECTED', catTimeBuilded)
            this.$store.commit('sla/SET_CAT_SETTING_SELECTED', this.catSettingValue)
            console.log(this.$store.state)
            this.isLoading = false
            
        },

        async onFetchCatTime(catCode){
            const cmType = this.$store.getters["sla/getCmTypeSelected"]
            console.log("cmType=>", cmType, this.type )
            let result = null

            if(this.type == "cm"){
                result = await CatService.GetCMCatTime(this.paramSubCompanyId, catCode, cmType)
                // if(cmType !=="bangkok"){
                //     result = await CatService.GetCMCatTime(this.paramSubCompanyId, catCode, cmType)
                // }else{
                //     result = await CatService.GetCatTimeByTypeAndCat(this.paramSubCompanyId, this.type, catCode)
                // }
            }else{
                result = await CatService.GetCatTimeByTypeAndCat(this.paramSubCompanyId, this.type, catCode)
            }
            
            
            
            return result.data            
        },
       
        buidCatTime(data){
            const schedule = {};
            data.forEach(({ day, startTime, endTime, isEnable }) => {
                schedule[day] = {
                isEnable:isEnable,
                startTime: startTime.slice(0, 5), // Extract "HH:MM"
                endTime: endTime.slice(0, 5)
                };
            });

            return schedule;
        },
        convertHourToText(time) {
            // Extract integer part as hours and decimal part as minutes
            const hours = Math.floor(time);
            const minutes = Math.round((time % 1) * 100); // Convert decimal part to minutes correctly

            const totalMinutes = (hours * 60) + minutes;
            const days = Math.floor(totalMinutes / 1440); // 1 day = 1440 minutes
            const remainingMinutes = totalMinutes % 1440;
            const finalHours = Math.floor(remainingMinutes / 60);
            const finalMinutes = remainingMinutes % 60;

            let result = [];
            if (days > 0) result.push(`${days} day${days > 1 ? 's' : ''}`);
            if (finalHours > 0) result.push(`${finalHours} hour${finalHours > 1 ? 's' : ''}`);
            if (finalMinutes > 0) result.push(`${finalMinutes} minute${finalMinutes > 1 ? 's' : ''}`);

            return result.length > 0 ? result.join(' ') : '0 minute';
        },                    
        validateCat(catData) {
            const requiredKeys = ["CAT1", "CAT2", "CAT3", "CAT4"];            
            const isAllZero = requiredKeys.every(catCode => this.catSettingValue[catCode] == 0);
            if (isAllZero) return true; // ถ้าทุกอันเป็น 0 ไม่ต้องเช็คอะไร

            // ถ้าไม่ใช่ 0 ทั้งหมด ให้เช็คเฉพาะตัวที่ไม่ใช่ 0
            return requiredKeys.every(catCode => this.catSettingValue[catCode] && this.catTimesAmount[catCode].length > 0);
        }, 
        displayCatTimeDetail(catCode){
            const info = {count:0, mondayInfo:null}
            if(this.catTimesAmount[catCode].length > 0){
                const countEnable = this.catTimesAmount[catCode].filter(catTime=>catTime.isEnable)
                const mondayData = this.catTimesAmount[catCode].find(catTime=>catTime.day=="monday")
                info.count = countEnable.length
                info.mondayInfo = `${this.convertTime(mondayData.startTime)} - ${this.convertTime(mondayData.endTime)}`


                
            }

            return info
            
        }, 
        convertTime(time) {
                    const [hour, minute, second] = time.split(":");
                    return `${hour.padStart(2, "0")}:${minute.padStart(2, "0")}`;
        },      
        onSubmit() {
            console.log("this.catSettingValue=>", this.catSettingValue)
            const isValid = this.validateCat(this.catSettingValue)
            if(!isValid){
                alert("กรุณากรอกข้อมูลและเวลาของ CAT 1 - CAT 4 ให้ครบ")
                return
            }

            this.$emit('onSubmit', this.catSettingValue)
        }

    }
}
</script>

<style scoped>
.hoverRow:hover {
    background-image: linear-gradient(to right, rgba(226, 235, 235, 1), rgba(226, 235, 235, 0));
}
</style>